module.exports = __webpack_public_path__ + "img/bright-blue-rec.6940ecf9.svg";